import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Sun = (props: Icon): React.ReactElement => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    style={{ ...style(props.size, props.height), ...props.style }}
  >
    <g
      stroke={props.color || theme.palette.grey600}
      strokeWidth="2"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M15.546 11a4.545 4.545 0 11-9.091 0 4.545 4.545 0 119.09 0zM21 6.858l-4.166-1.691L15.167 1m0 0L11 2.667 6.834 1m0 0L5.167 5.167 1 6.857m0 0L2.667 11 1 15.142m0 0l4.167 1.692L6.834 21m0 0L11 19.334 15.167 21m0 0l1.667-4.166L21 15.142m0 0L19.334 11 21 6.858" />
    </g>
  </svg>
);
